// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-header {
    color: white;
    padding: 10px;
    /* padding-left: 120px;
    padding-right: 100px; */
    border-top-left-radius: 1px;
    border-top-right-radius: 1px;
    display: flex;
    justify-content: center;
  }
  .modal-content {
    padding: 20px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modal-actions {
    padding: 10px;
    /* padding-left: 150px;
    padding-right: 120px; */
    display: flex;
    justify-content: center;
    /* align-items: flex-end; */
  }
  
 `, "",{"version":3,"sources":["webpack://./src/app/shared/component/commondialog/commondialog.component.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,aAAa;IACb;2BACuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb;2BACuB;IACvB,aAAa;IACb,uBAAuB;IACvB,2BAA2B;EAC7B","sourcesContent":["\n.modal-header {\n    color: white;\n    padding: 10px;\n    /* padding-left: 120px;\n    padding-right: 100px; */\n    border-top-left-radius: 1px;\n    border-top-right-radius: 1px;\n    display: flex;\n    justify-content: center;\n  }\n  .modal-content {\n    padding: 20px;\n    padding-left: 80px;\n    padding-right: 80px;\n  }\n  .modal-actions {\n    padding: 10px;\n    /* padding-left: 150px;\n    padding-right: 120px; */\n    display: flex;\n    justify-content: center;\n    /* align-items: flex-end; */\n  }\n  \n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
